import { render, staticRenderFns } from "./PassChangePopupComp.vue?vue&type=template&id=3ab2bb9a&scoped=true&"
import script from "./PassChangePopupComp.vue?vue&type=script&lang=js&"
export * from "./PassChangePopupComp.vue?vue&type=script&lang=js&"
import style0 from "./PassChangePopupComp.vue?vue&type=style&index=0&id=3ab2bb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2bb9a",
  null
  
)

export default component.exports